import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Logo } from "@resources";
import { helpers } from "@shared";
import managePaymentsImg from "@illustrations/manage-payments-364x364.png";
import payorsImg from "@illustrations/payors-364x364.png";
import { Button } from '@common';

const Welcome = () => {

    const navigate = useNavigate(), location = useLocation();

    const next = () => {
        helpers.navigateNext(location, navigate);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="flex flex-col w-full">
            <div className="flex flex-col gap-2 mb-6 md:mb-8">
                <h1 className="text-[20px] leading-[24px] md:text-[28px] md:leading-[40px] font-medium text-neutral-950 tracking-[0.2px] md:tracking-[0.28px] flex items-center gap-2">
                    Welcome to <Logo className="h-[29px] w-auto text-neutral-950" />
                </h1>
                <p className="text-sm leading-5 md:text-base md:leading-6 text-neutral-700 tracking-[0.14px]">
                    The best way to pay for senior living.
                </p>
            </div>

            <div className="flex flex-col gap-4 mb-8">
                <h2 className="text-base leading-6 md:text-xl md:leading-7 font-medium text-neutral-950 tracking-[0.16px]">
                    Member Benefits
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
                    {/* Pay Your Way Card */}
                    <div className="flex flex-col gap-4">
                        <div className="flex justify-center items-center">
                            <img src={managePaymentsImg} alt="Illustration of a bank (ACH) and credit/debit cards, representing the various payment methods offered by Sunbound" className="w-[182px] h-[182px]" />
                        </div>
                        <div className="flex flex-col gap-1 text-left">
                            <h3 className="text-base leading-6 font-medium text-neutral-950 tracking-[0.16px]">
                                Pay Your Way
                            </h3>
                            <p className="text-sm leading-5 text-neutral-700 tracking-[0.14px]">
                                Make payments via ACH or credit card. Set it and forget it with autopay.
                            </p>
                        </div>
                    </div>

                    {/* Pay Collaboratively Card */}
                    <div className="flex flex-col gap-4">
                        <div className="flex justify-center items-center">
                            <img src={payorsImg} alt="Illustration of several persons' hands high-fiving, representing how collaborative payments are available through Sunbound's platform" className="w-[182px] h-[182px]" />
                        </div>
                        <div className="flex flex-col gap-1 text-left">
                            <h3 className="text-base leading-6 font-medium text-neutral-950 tracking-[0.16px]">
                                Pay Collaboratively
                            </h3>
                            <p className="text-sm leading-5 text-neutral-700 tracking-[0.14px]">
                                Invite family members to help pay the rent balance each month.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <Button
                type="button"
                variant="primary"
                size="lg"
                className="w-full"
                onClick={next}
            >
                Continue
            </Button>
        </div>
    );
};

export default Welcome;
